import { useTranslation } from 'react-i18next';

import { ICliJob } from 'cliOld/types';
import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useNotification } from 'coreOld/hooks/useNotification';
import { getDomainUrl } from 'coreOld/utils';

interface IGenerateFileOptions {
  exportSuccessMessage?: string;
}

const downloadFilePath = (fileId: string) =>
  `${getDomainUrl()}/files/index/download/file/${fileId}`;

const getFileId = (file) => {
  const result = JSON.parse(file);

  return result.file_id || result.report_file_id;
};

const downloadFile = (cliJob: ICliJob) => {
  window.location.href = downloadFilePath(getFileId(cliJob.result));
};

export const useGenerateFile = () => {
  const { t } = useTranslation();
  const { showNotification } = useNotification();

  const onGenerateFileFinished = (cliJob: ICliJob, options?: IGenerateFileOptions) => {
    const defaultOptions = {
      exportSuccessMessage: t('messageGenerateExportFileSuccess'),
      ...options,
    };

    showNotification({
      type: ApiStatuses.SUCCESS,
      message: defaultOptions.exportSuccessMessage,
      position: NotificationPosition.TOP,
    });

    downloadFile(cliJob);
  };

  const onGenerateFileStopped = (cliJob: ICliJob) => {
    const errorMessage = t('errorGenerateExportFilePrefix', {
      errorMessage: cliJob.statusDescription || t('serverError'),
    });

    showNotification({
      type: ApiStatuses.ERROR,
      message: errorMessage,
      position: NotificationPosition.TOP,
    });
  };

  return { onGenerateFileFinished, onGenerateFileStopped };
};
